import React, { Component } from "react";
import Delete from "../assets/delete1.png";
import EditLinkedin from "../LinkedinForm/EditLinkedinProfile";
import "./linkedInstep.css";
import { connect } from "react-redux";
import { Table, TableBody, TableRow } from "@material-ui/core";
import store from "../../Redux/Store";
import swal from "sweetalert";
import { fetchMethod } from "../../FetchMethod";
import { updateCustomerLinkedinCreate } from "./Customerquery";

class AddLinkedinModal extends Component {
  changePassword = str => {
    var a = "*";
    var b = "";
    if (str === "") return str;
    for (var i = 0; i < 5; i++) {
      b += a;
    }
    return b;
  };
  onDelete = item => {
    if (item.active === 1 || item.active === "1") {
      swal({
        title: "Are you sure you want to delete this profile?",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          const test = {
            id: { linkedinemail: item.linkedinemail, id: item.id },
            data: { active: 0 }
          };
          fetchMethod(updateCustomerLinkedinCreate, test)
            .then(response => {
              return response.json();
            })
            .then(res => {
              this.props.OnDeleteData(item.id);
            })
            .catch(e => console.log(e));
        }
      });
    }
  };
  render() {
    return (
      <React.Fragment>
        {this.props.addLinkedinStep.length !== 0 ? (
          this.props.addLinkedinStep.map(item => {
            return (
              <table
                style={{
                  width: "100%",
                  padding: "15px 15px 10px",
                  borderBottom: "1px solid #babfbb"
                }}
              >
                <tr>
                  <th style={{ textAlign: "left", wordBreak: "break-word" }}>
                    {item.name}
                  </th>

                  <th style={{ textAlign: "right" }}>
                    <EditLinkedin editableData={item} />
                  </th>
                  <th>
                    <a
                      title="Delete"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        store.getState().isEditMode === true
                          ? this.onDelete(item)
                          : swal({
                              title:
                                "Are you sure you want to delete this LinkedIn profile?",
                              icon: "warning",
                              buttons: true,
                              dangerMode: true
                            }).then(willDelete => {
                              if (willDelete) {
                                this.props.OnDelete(item.linkedinemail);
                              }
                            })
                      }
                    >
                      <img src={Delete} alt="Delete" />
                    </a>
                  </th>
                </tr>
                <tr>
                  <td style={{ width: "50px" }}>LinkedIn</td>
                  <td>{item.linkedinemail}</td>
                  <td>{this.changePassword(item.linkedinpassword)}</td>
                </tr>
                <tr>
                  <td style={{ width: "50px" }}>Salesforce</td>
                  <td>
                    {item.salesforcetoken ? "Connected" : "Not Connected"}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style={{ width: "50px" }}>HubSpot</td>
                  <td>{item.hubspottoken ? "Connected" : "Not Connected"}</td>
                  <td></td>
                </tr>
              </table>
            );
          })
        ) : (
          <div className="Table1">
            <Table>
              <TableBody>
                <TableRow>No Profile</TableRow>
              </TableBody>
            </Table>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { addLinkedinStep } = state;
  return { addLinkedinStep };
};
const mapDispatchToProps = dispatch => {
  return {
    OnDelete: linkedinemail => {
      dispatch({ type: "Delete_Result", LinkedinId: linkedinemail });
    },
    OnDeleteData: linkedinemail => {
      dispatch({ type: "Delete_Result_Data", LinkedinId: linkedinemail });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddLinkedinModal);
